import * as React from 'react';

export default function PageContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 pb-16">
      {children}
    </div>
  );
}
